/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiPromsyConfiguration as __Configuration } from '../api-promsy-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { VersionSistema } from '../models/version-sistema';
import { VUsuarioPromsy } from '../models/vusuario-promsy';
@Injectable({
  providedIn: 'root',
})
class SistemaService extends __BaseService {
  static readonly HomeGetQRCodeImagePath = '/GetQRCodeImage';
  static readonly HomeIndexPath = '/';
  static readonly HomeValidatePinPath = '/ValidatePin';
  static readonly HomeWhoAmIPath = '/WhoAmI';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Generate a QR Image.
   * @return OK
   */
  HomeGetQRCodeImageResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/GetQRCodeImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * Generate a QR Image.
   * @return OK
   */
  HomeGetQRCodeImage(): __Observable<string> {
    return this.HomeGetQRCodeImageResponse().pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * Acción principal del sistema, con la versión de compilado dependiendo de la cabecera de Mercurial.
   * @return OK
   */
  HomeIndexResponse(): __Observable<__StrictHttpResponse<{[key: string]: VersionSistema}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: VersionSistema}>;
      })
    );
  }
  /**
   * Acción principal del sistema, con la versión de compilado dependiendo de la cabecera de Mercurial.
   * @return OK
   */
  HomeIndex(): __Observable<{[key: string]: VersionSistema}> {
    return this.HomeIndexResponse().pipe(
      __map(_r => _r.body as {[key: string]: VersionSistema})
    );
  }

  /**
   * Valid a Pin.
   * @param params The `SistemaService.HomeValidatePinParams` containing the following parameters:
   *
   * - `pin`:
   *
   * - `Authorization`: Autorización (Ejemplo: "Bearer Token")
   *
   * @return OK
   */
  HomeValidatePinResponse(params: SistemaService.HomeValidatePinParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pin != null) __params = __params.set('pin', params.pin.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ValidatePin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * Valid a Pin.
   * @param params The `SistemaService.HomeValidatePinParams` containing the following parameters:
   *
   * - `pin`:
   *
   * - `Authorization`: Autorización (Ejemplo: "Bearer Token")
   *
   * @return OK
   */
  HomeValidatePin(params: SistemaService.HomeValidatePinParams): __Observable<boolean> {
    return this.HomeValidatePinResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * Obtiene información del usuario logueado.
   * @return OK
   */
  HomeWhoAmIResponse(): __Observable<__StrictHttpResponse<VUsuarioPromsy>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/WhoAmI`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VUsuarioPromsy>;
      })
    );
  }
  /**
   * Obtiene información del usuario logueado.
   * @return OK
   */
  HomeWhoAmI(): __Observable<VUsuarioPromsy> {
    return this.HomeWhoAmIResponse().pipe(
      __map(_r => _r.body as VUsuarioPromsy)
    );
  }
}

module SistemaService {

  /**
   * Parameters for HomeValidatePin
   */
  export interface HomeValidatePinParams {
    pin: string;

    /**
     * Autorización (Ejemplo: "Bearer Token")
     */
    Authorization?: string;
  }
}

export { SistemaService }
